/*
 * Author: harper
 * File Created: Monday, 23-11-20 03:54 pm
 * Last Modified: Monday, 24-11-25 11:12 am, by Dw
 * Copyright © 2023 - Liberty MIT
 */

import { PropsWithChildren } from 'react';
import Dialogs from '../dialog';
import GloablSnackbar from '../snackbar';
export default function MessageWrapper({
  children
}: PropsWithChildren) {
  return <div id="dialog-wrapper" style={{
    overflow: 'hidden'
  }} data-sentry-component="MessageWrapper" data-sentry-source-file="index.tsx">
      {children}
      <Dialogs data-sentry-element="Dialogs" data-sentry-source-file="index.tsx" />
      <GloablSnackbar data-sentry-element="GloablSnackbar" data-sentry-source-file="index.tsx" />
    </div>;
}